export default __webpack_public_path__ + "static/media/Success.1c67d4c3.svg";